import { Component, OnDestroy, OnInit, NgZone } from '@angular/core';
import { APIService } from '../../../api/api.service';
import { NotifierService } from '../../../_services/notifier.service';
import * as moment from 'moment';
declare let window: any;
declare let $: any;

@Component({
  selector: 'app-wrpnl',
  templateUrl: './wrpnl.component.html',
  styleUrls: ['./wrpnl.component.css'],
})
export class WrpnlComponent implements OnInit {
  accountId: string;
  regionId: string;
  data_fetch: any = []; // Initialize as an empty array
  dateRange: any;
  currentMessage: any;
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  headers: any = [
    {
      id: 'accountId',
      name: 'Account ID',
      show: true,
      sort: { sort: true, direction: 'Asc' },
      type: 'String',
      filter: true,
      style: { width: 0 },
    },
    {
      id: 'accountName',
      name: 'Account Name',
      show: true,
      sort: { sort: true, direction: 'Asc' },
      type: 'String',
      filter: true,
      style: { width: 0 },
    },
    { id: 'totalOd', name: 'Total OD', sort: { sort: true, direction: 'Asc' } },
    {
      id: 'saleValue',
      name: 'Sales Value',
      sort: { sort: true, direction: 'Asc' },
    },
    {
      id: 'spAndNotCov',
      name: 'SP And Not Cov',
      sort: { sort: true, direction: 'Asc' },
    },
    {
      id: 'wrSavings',
      name: 'WR Savings',
      sort: { sort: true, direction: 'Asc' },
    },
    {
      id: 'wrSavingsPnl',
      name: 'WR Savings PNL',
      sort: { sort: true, direction: 'Asc' },
    },
    {
      id: 'notCovOd',
      name: 'Not Cov OD',
      sort: { sort: true, direction: 'Asc' },
    },

    // { id: 'spPurchase', name: 'SP Purchase', sort: { sort: true, direction: 'Asc' } },
  ];

  constructor(
    public notifier: NotifierService,
    private apiService: APIService,
    private zone: NgZone
  ) {}

  ngOnInit(): void {
    this.accountId = localStorage.getItem('accountId');
    this.regionId = localStorage.getItem('regionId');
    let temp = moment(new Date());
    // this.fetch();

    window.angularComponentReference = {
      zone: this.zone,
      componentFn: (docName: any, fileSize: any, targetDocBase64: any) =>
        this.fetch(),
      component: this,
    };

    this.dateRange = temp.format('MM/YYYY');
    $('#datetimepicker')
      .datepicker({
        autoclose: true,
        minViewMode: 1,
        format: 'mm/yyyy',
        orientation: 'bottom auto',
        endDate: new Date(),
      })
      .on('changeDate', function (selected: any) {
        window.angularComponentReference.zone.run(() => {
          window.angularComponentReference.componentFn();
        });
      });

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) {
        return;
      }
      if (d.key == 'accountId') {
        this.accountId = d.value;
        this.fetch();
      } else if (d.key == 'regionId') {
        this.regionId = d.value;
        this.fetch();
      }
    });
  }

  //  async fetch(){
  //     this.notifier.loading(true);
  //     let dRange: any = $('#monthDate').val() || this.dateRange;
  //     let sData = moment(dRange, 'MM/YYYY').format('MM-YYYY');
  //     console.log("type",typeof('sData'));
  //     let data = { month: sData,
  //                   a: 'fetch' };
  //     let header = {
  //       Authorization: localStorage.getItem('t'),
  //     };
  //     let apiURL = `https://api.swayam.cloud/v3/admin/billing/wr-pnl`;
  //     let result = await this.apiService.postDataPromis(apiURL, data, header);
  //     if (result.status == '1' || result.s == '1') {
  //       setTimeout(()=>{
  //         this.data_fetch = result.data;

  //       },1000)
  //     } else {
  //       setTimeout(()=>{
  //         this.data_fetch = [];

  //       },1000)
  //       this.notifier.alert('Info', '', result.msg, 'info', 5000);
  //     }
  //     this.notifier.loading(false);
  //   }
  ngOnDestroy(): void {
    this.currentMessage.unsubscribe();
  }

  export() {
    window.exportToExcel('WR-Pnl-Report', `WR-Pnl-Report`, 'csv');
  }

  // async fetch(refresh: boolean = false, nextToken: any = undefined) {
  //   if (refresh || !nextToken) {
  //     this.data_fetch = [];
  //   }
  //   this.notifier.loading(true);
  //   let monthYear = moment().startOf('month').format('YYYY-MM');

  //   let dRange = $('#datetimepicker').val();
  //   if (dRange) {
  //     const parts = dRange.toString().split('/');
  //     monthYear = parts[1] + '-' + parts[0]; // "2025-08"
  //   }

  //   this.dateRange = monthYear;
  //   let data = {
  //     monthYear: monthYear,
  //     action: 'fetch',
  //     nt: nextToken,
  //   };

  //   let header = {
  //     Authorization: localStorage.getItem('t'),
  //   };
  //   let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/fetchsputilization`;

  //   let result = await this.apiService.postDataPromis(apiURL, data, header);

  //   if (data.monthYear != this.dateRange) {
  //     return;
  //   }
  //   if (
  //     (result.statusCode == '1' || result.s == '1') &&
  //     result.details &&
  //     result.details.length > 0
  //   ) {
  //     this.data_fetch = result.details.map((ri: any) => {
  //       const totalOd =
  //         Number(ri['total OD'] || 0) + Number(ri['sp_covered_usage'] || 0);
  //       const salesValue = 5;
  //       const spAndNotCov =
  //         Number(ri['sp_purchased'] || 0) +
  //         Number(ri['sp_on_demand_not_covered'] || 0);
  //       const wrSavings = Number(ri['sp_net_savings'] || 0);
  //       const wrSavingsPnl = wrSavings / salesValue;
  //       const notCovOd = Number(ri['sp_on_demand_not_covered'] || 0);

  //       return {
  //         accountId: ri.accountId,
  //         accountName: ri.accountName,
  //         totalOd: totalOd.toFixed(2),
  //         salesValue: salesValue,
  //         spAndNotCov: spAndNotCov.toFixed(2),
  //         wrSavings: wrSavings.toFixed(2),
  //         wrSavingsPnl: wrSavingsPnl.toFixed(2),
  //         notCovOd: notCovOd.toFixed(2),
  //         sp_purchased: ri.sp_purchased,
  //         'Last 7 Days OD': ri.day_wise
  //           ? ri.day_wise.reduce(
  //               (acc: number, obj: any) => acc + Number(obj.total_od),
  //               0
  //             )
  //           : 0,
  //       };
  //     });
  //   } else {
  //     this.data_fetch = [];
  //   }
  //   this.notifier.loading(false);
  // }

  // 🔹 Main fetch method (excerpt with relevant part)
  async fetch(refresh: boolean = false, nextToken: any = undefined) {
    if (refresh || !nextToken) {
      this.data_fetch = [];
    }

    this.notifier.loading(true);

    let monthYear = moment().startOf('month').format('YYYY-MM');
    const dRange = $('#datetimepicker').val();
    if (dRange) {
      const parts = dRange.toString().split('/');
      monthYear = `${parts[1]}-${parts[0]}`; // "2025-08"
    }
    this.dateRange = monthYear;

    const data = {
      monthYear,
      action: 'fetch',
      nt: nextToken,
    };

    const header = {
      Authorization: localStorage.getItem('t'),
    };

    const apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/fetchsputilization`;
    const result = await this.apiService.postDataPromis(apiURL, data, header);

    if (data.monthYear !== this.dateRange) {
      this.notifier.loading(false);
      return;
    }

    if (
      (result.statusCode == '1' || result.s == '1') &&
      result.details &&
      result.details.length > 0
    ) {
      const processedData = await Promise.all(
        result.details.map(async (ri: any) => {
          const accountId = ri.accountId;

          console.log('🔹 Calling calculateTotalSalesValue for', accountId);

          const totalSalesValue = await this.calculateTotalSalesValue(
            accountId,
            monthYear
          );

          console.log(
            '✅ Total Sales Value for',
            accountId,
            '=',
            totalSalesValue
          );

          // --- existing calculations ---
          const totalOd =
            Number(ri['total OD'] || 0) + Number(ri['sp_covered_usage'] || 0);
          const spAndNotCov =
            Number(ri['sp_purchased'] || 0) +
            Number(ri['sp_on_demand_not_covered'] || 0);
          const wrSavings = Number(ri['sp_net_savings'] || 0);
          const saleValueNum = Number(ri.saleValue);
          const wrSavingsPnl = !saleValueNum || isNaN(saleValueNum) ? 0 : wrSavings / saleValueNum;

          const notCovOd = Number(ri['sp_on_demand_not_covered'] || 0);

          return {
            accountId: ri.accountId,
            accountName: ri.accountName,
            totalOd: totalOd.toFixed(2),
            saleValue: ri.saleValue,
            spAndNotCov: spAndNotCov.toFixed(2),
            wrSavings: wrSavings.toFixed(2),
            wrSavingsPnl: wrSavingsPnl.toFixed(2),
            notCovOd: notCovOd.toFixed(2),
            sp_purchased: ri.sp_purchased,
            'Last 7 Days OD': ri.day_wise
              ? ri.day_wise.reduce(
                  (acc: number, obj: any) => acc + Number(obj.total_od),
                  0
                )
              : 0,
          };
        })
      );

      this.data_fetch = processedData;
    } else {
      this.data_fetch = [];
    }

    this.notifier.loading(false);
  }

  /**
   * 🔹 Get list of child accounts for a given master account
   */
  private async getChildAccounts(parentId: string): Promise<any[]> {
    const header = { Authorization: localStorage.getItem('t') };
    const url = `https://api.swayam.cloud/prod/msopsusers/billing/fetchmasteraccountlist`;
    const payload = {
      action: 'fetchAllChildAccountList',
      masterAccountID: parentId,
    };

    try {
      const res = await this.apiService.postDataPromis(url, payload, header);
      console.log('👶 Child accounts API response:', res);

      // Adjust depending on your API response structure
      const children =
        res?.childAccountDetailsList ||
        res?.response?.childAccountDetailsList ||
        [];

      console.log(`✅ Found ${children.length} child accounts for`, parentId);

      return children;
    } catch (err) {
      console.error('❌ Error fetching child accounts for', parentId, err);
      return [];
    }
  }

  /**
   * 🔹 Get detailed sales value for each child account
   */
  private async getChildAccountValue(
    parentId: any,
    childId: string,
    monthYear: string
  ): Promise<number> {
    const header = { Authorization: localStorage.getItem('t') };
    const url = `https://api.swayam.cloud/prod/msopsusers/billing/fetchmasteraccountlist`;
    const payload = {
      masterAccId: parentId,
      month_year: monthYear,
      lid: [childId],
      userType: 'C',
      action: 'supportPlanDetails',
    };

    try {
      console.log(
        `📦 Fetching details for child ${childId} of parent ${parentId}`
      );
      const res = await this.apiService.postDataPromis(url, payload, header);
      console.log('🔹 Child details response:', res);

      // Adjust based on API return field (example: res.details[0].salesValue)
      const val =
        Number(res?.value) ||
        Number(res?.details?.[0]?.saleValue) ||
        Number(res?.response?.saleValue) ||
        0;

      console.log(`✅ Child ${childId} value:`, val);
      return val;
    } catch (err) {
      console.error(`❌ Error fetching details for child ${childId}`, err);
      return 0;
    }
  }

  /**
   * 🔹 Combine both calls and calculate total sales value for the parent
   */
  private async calculateTotalSalesValue(
    parentId: string,
    monthYear: string
  ): Promise<number> {
    console.log('🧮 Calculating total sales for parent', parentId);
    const children = await this.getChildAccounts(parentId);

    console.log('👶 Children result:', children);

    if (!children.length) {
      console.warn('⚠️ No children found for parent', parentId);
      return 0;
    }

    const values = await Promise.all(
      children.map((child: any) =>
        this.getChildAccountValue(parentId, child.accountId, monthYear)
      )
    );

    const total = values.reduce((a, b) => a + b, 0);
    console.log(`💰 Total sales value for ${parentId}:`, total);

    return total;
  }

  // private async getChildAccounts(parentId: string): Promise<any[]> {
  //   const header = { Authorization: localStorage.getItem('t') };
  //   const url = `https://api.swayam.cloud/prod/msopsusers/billing/fetchmasteraccountlist`;
  //   const payload = {
  //     "action": "fetchAllChildAccountList",
  //     "masterAccountID": parentId
  // };

  //   const res = await this.apiService.postDataPromis(url, payload, header);
  //   console.log(res);
  //   return res?.details || [];
  // }

  // private async getChildAccountValue(parentId:any, childId: string, monthYear: string): Promise<number> {
  //   console.log('method called');
  //   const header = { Authorization: localStorage.getItem('t') };
  //   const url = `https://dev.api.swayam.cloud/v3/admin/billing/getservicelevelbill`;
  //   const payload = {
  //     "masterAccId": parentId,
  //     "month_year": monthYear,
  //     "lid": [
  //         childId
  //     ],
  //     "userType": "C",
  //     "action": "supportPlanDetails",
  // };

  //   const res = await this.apiService.postDataPromis(url, payload, header);
  //   console.log('res',res);
  //   // assume API returns a numeric field (update key as per your API)
  //   return Number(res?.value || 0);
  // }

  // private async calculateTotalSalesValue(parentId: string, monthYear: string): Promise<number> {
  //   const children = await this.getChildAccounts(parentId);
  //   if (!children.length) return 0;
  // console.log(children)
  //   const values = await Promise.all(
  //     children.map((child) => this.getChildAccountValue(parentId,child.accountId, monthYear))
  //   );

  //   return values.reduce((a, b) => a + b, 0);
  // }

  onSalesValueChange(row: any): void {
    const wrSavings = row.wrSavings ?? 0;
    const saleValue = row.saleValue || 5;
    row.wrSavingsPnl = saleValue ? wrSavings / saleValue : 0;
  }
}
